import React, { useEffect, useState } from 'react';
import Slider from 'react-slick';
import {
    FlexCol, FlexContainer, FlexRow, ScrollContainer, ScrollLine, ScrollIcon,
    ScrollText, HighlightText, HoverText, HoverImage, HLButton, FloatingTitle
} from '../Styles';
import { font_h4, handCursor } from './../Constant/constant';
import TestimonialCard from './../Component/Components/TestimonialCard';
import Typed from 'typed.js';
import { useHistory } from "react-router-dom";
import Fade from 'react-reveal/Fade';
import Bounce from 'react-reveal/Bounce';
import Slide from 'react-reveal/Slide';
import Pulse from 'react-reveal/Pulse';
import Flash from 'react-reveal/Flash';
import Zoom from 'react-reveal/Zoom';

import Shashank from './../assets/Testimonials/shashank.webp';
import Priyal from './../assets/Testimonials/priyal.webp';
import Avicia from './../assets/Testimonials/avicia2.webp';
import Gourab from './../assets/Testimonials/gourab.webp';
import Steve from './../assets/Testimonials/steve.webp';
import TwitterRed from './../assets/Projects/TwitterRed.webp';
import MADProject from './../assets/Projects/MADProject.webp';
import StandWeSpeak from './../assets/Projects/StandWeSpeak.webp';

import process1 from './../assets/Others/process1.webp';
import process2 from './../assets/Others/process2.webp';
import process3 from './../assets/Others/process3.webp';


import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./style.css";

const HomePage = () => {
    let history = useHistory();

    const testimonials = [
        {
            name: 'Shashank',
            position: 'Founder of The Renal Project',
            comment: 'Good with imagination, understanding of requirments and comfortable to work with.',
            img: Shashank,
            link: 'https://www.therenalproject.com/'
        },
        // {
        //     name: 'Priyal Agrawal',
        //     position: 'Founder & CEO, StandWeSpeak',
        //     comment: `Steven is a committed and a driven person with a sense of strong problem solving skills. 
        //                 During his tenure at StandWeSpeak, while working on various aspects of software development, he came up with innovative ideas and creative solutions to improve our product. 
        //                 He is a quick learner and adapts himself to new work environments. I recommend Steven for any challenging or dynamic role. He will surely be an asset to any company or organisation he join. 
        //                 I wish him all the best for his future endeavours.`,
        //     img: Priyal
        // },
        {
            name: 'Priyal Agrawal',
            position: 'Founder & CEO, StandWeSpeak',
            comment: `Steven is a committed and a driven person with a sense of strong problem solving skills. 
                        He came up with innovative ideas and creative solutions to improve our product. 
                        He is a quick learner and adapts himself to new work environments.
                        I wish him all the best for his future endeavours.`,
            img: Priyal,
            link: 'https://standwespeak.com/'
        },
        {
            name: 'Avicia Fernandes',
            position: 'Illustrator',
            comment: `Amazing person to work with! Hardworking individual, who delivers efficiently and on time. 
            I loved the outcome that Steven created, with my design inputs he exceeded my expectations.`,
            img: Avicia,
            link: 'http://aviciafernandes.in/'
        },
        {
            name: 'Gourab Sen',
            position: 'Asst. Manager of Indian Oil CO LTD',
            comment: 'Steven has a profound understanding of software development, so he knows exactly what client need and what our developers are looking for, and he can efficiently match the two.',
            img: Gourab,
            link: 'https://www.linkedin.com/in/gourab-sen-2564a060/'
        }
    ]

    const typedOptions = {
        strings: [
            '.',
            'Animator',
            'UI/UX Designer',
            'Sportsperson'
        ],
        startDelay: 1000,
        loop: true,
        loopCount: 10,
        backSpeed: 30,
        typeSpeed: 60,
        backDelay: 1800,
        showCursor: true,
        cursorChar: '.',
    };

    const settings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2500
    };
    const [screenSize, setscreenSize] = useState(window.innerWidth);

    const resizeWindow = () => {
        if (window.innerWidth !== screenSize) {
            setscreenSize(window.innerWidth);
        }
    }
    useEffect(() => {
        window.addEventListener("resize", resizeWindow);
        new Typed('.typist-style', typedOptions);
    }, [])

    return (
        <FlexContainer>
            <ScrollContainer>
                <ScrollLine></ScrollLine>
                <ScrollIcon>
                    <svg width="32" height="42" viewBox="0 0 32 52" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M16 10.375C16.4043 10.375 16.792 10.5396 17.0779 10.8327C17.3638 11.1257 17.5244 11.5231 17.5244 11.9375V18.1875C17.5244 18.6019 17.3638 18.9993 17.0779 19.2924C16.792 19.5854 16.4043 19.75 16 19.75C15.5957 19.75 15.208 19.5854 14.9221 19.2924C14.6362 18.9993 14.4756 18.6019 14.4756 18.1875V11.9375C14.4756 11.5231 14.6362 11.1257 14.9221 10.8327C15.208 10.5396 15.5957 10.375 16 10.375ZM28.1951 35.375C28.1951 38.6902 26.9103 41.8696 24.6233 44.2138C22.3362 46.5581 19.2344 47.875 16 47.875C12.7657 47.875 9.66378 46.5581 7.37675 44.2138C5.08972 41.8696 3.80488 38.6902 3.80488 35.375V16.625C3.80488 13.3098 5.08972 10.1304 7.37675 7.78618C9.66378 5.44197 12.7657 4.12501 16 4.12501C19.2344 4.12501 22.3362 5.44197 24.6233 7.78618C26.9103 10.1304 28.1951 13.3098 28.1951 16.625V35.375ZM16 1.00001C11.9571 1.00001 8.07973 2.64621 5.22094 5.57647C2.36215 8.50672 0.756104 12.481 0.756104 16.625L0.756104 35.375C0.756104 39.519 2.36215 43.4933 5.22094 46.4236C8.07973 49.3538 11.9571 51 16 51C20.0429 51 23.9203 49.3538 26.7791 46.4236C29.6379 43.4933 31.2439 39.519 31.2439 35.375V16.625C31.2439 12.481 29.6379 8.50672 26.7791 5.57647C23.9203 2.64621 20.0429 1.00001 16 1.00001V1.00001Z" fill="#0466C8" stroke="#0466C8" /> </svg>
                </ScrollIcon>
                <ScrollText>
                    Scroll Down
                </ScrollText>
            </ScrollContainer>

            <FlexRow>
                <FlexCol basis="60%" className="home-title">
                    Steven Fernandes
                </FlexCol>
                <FlexCol basis="60%" className="home-skill-static" >
                    Developer
                </FlexCol>
                <FlexCol basis="60%" className="home-skill-dynamic">
                    +  <div
                        className="typist-style">
                        Animator
                        </div>
                </FlexCol>
            </FlexRow>
            <FlexRow align="flex-start">
                <FloatingTitle>About</FloatingTitle>
                <FlexCol basis="90%" style={{ fontSize: font_h4, textAlign: 'center' }}>Welcome to my World. My name is <HighlightText>Steven ;)</HighlightText></FlexCol>
                <FlexCol basis="90%" style={{ textAlign: 'center', lineHeight: '24px' }}>You might be probably wondering who am I?</FlexCol>
                <FlexCol basis="90%" style={{}}>
                    <FlexRow justify="space-between">
                        <FlexCol size="1" basis={screenSize > 800 ? "45%" : screenSize > 500 ? "80%" : "100%"} style={{ textAlign: 'justify', letterSpacing: '1.2px', lineHeight: screenSize > 800 ? '28px' : '1', padding: screenSize > 800 ? '0' : '20px', margin: '0 auto' }}>
                            <br />
                            <Fade duration={3000}>
                                <div>
                                    <div>
                                        I am an <HighlightText>web designer</HighlightText> and <HighlightText>full-stack developer</HighlightText>.
                            Proficient with building wireframes, designing animations, programming websites, programming applications and automating tasks.
                            Live in Mumbai.<br />
                            In my spare time I <HighlightText>{'<Heart/>'}</HighlightText> to play <HighlightText>Football</HighlightText> with friends, hog on <HighlightText>cheesy pizza</HighlightText>, read books and write <HighlightText>{'<Code/>'}</HighlightText>.
                            </div>
                                </div>
                            </Fade>
                        </FlexCol>
                        <FlexCol size="1" basis={screenSize > 800 ? "45%" : screenSize > 500 ? "80%" : "100%"} style={{ margin: 'auto' }}>
                            <Fade>
                                <img
                                    style={{ objectFit: 'contain', maxHeight: 240, width: '100%' }}
                                    src={Steve}
                                    alt="steven fernandes"
                                // src="https://images.unsplash.com/photo-1503023345310-bd7c1de61c7d?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=401&q=80"
                                />
                            </Fade>
                        </FlexCol>
                    </FlexRow>
                </FlexCol>
            </FlexRow>
            <FlexRow>
                <FloatingTitle>Position</FloatingTitle>
                <FlexCol basis="90%" style={{ fontSize: font_h4, textAlign: 'center' }}>What do I do?</FlexCol>
                <FlexCol basis="90%" style={{ textAlign: 'center', lineHeight: '24px' }}>a a Full Stack Developer I Want To Explore Every Tech Stack</FlexCol>
                <FlexCol style={{ flexWrap: 'wrap' }} className="home-process">
                    <FlexRow justify="center">
                        <FlexCol basis="30%" style={{ position: 'relative', top: -64 }}>
                            <img
                                style={{ objectFit: 'cover', height: 240, width: 240, borderRadius: 30, filter: 'brightness(0.8)' }}
                                src={process1}
                                alt="software management"
                            />
                            <HoverText>
                                <Bounce>
                                    <div style={{ fontSize: 'inherit', color: 'inherit' }}>Create Mockups</div>
                                </Bounce>
                            </HoverText>

                        </FlexCol>
                        <FlexCol basis="30%" style={{ position: 'relative' }}>
                            <img
                                style={{ objectFit: 'cover', height: 240, width: 240, borderRadius: 30, filter: 'brightness(0.8)' }}
                                src={process2}
                                alt="software management"
                            />

                            <HoverText>
                                <Bounce delay={500}>
                                    <div style={{ fontSize: 'inherit', color: 'inherit' }}>Integrate {'&'} Build</div>
                                </Bounce>
                            </HoverText>
                        </FlexCol>
                        <FlexCol basis="30%" style={{ position: 'relative', top: 64 }}>
                            <img
                                style={{ objectFit: 'cover', height: 240, width: 240, borderRadius: 30, filter: 'brightness(0.8)' }}
                                src={process3}
                                alt="software management"
                            />
                            <HoverText>
                                <Bounce delay={1000}>
                                    <div style={{ fontSize: 'inherit', color: 'inherit' }} >Test {'&'} Deploy</div>
                                </Bounce>
                            </HoverText>
                        </FlexCol>
                    </FlexRow>
                </FlexCol>
            </FlexRow>
            <FlexRow>
                <FloatingTitle style={{ top: '13%%' }}>My Work</FloatingTitle>
                <FlexCol basis="90%" style={{ fontSize: font_h4, textAlign: 'center' }}>What i have worked on?</FlexCol>
                <FlexCol basis="90%" style={{ textAlign: 'center', lineHeight: '24px' }}>my projects up untill now</FlexCol>
                <FlexCol style={{ position: 'relative', minHeight: 400 }} className="home-projects">
                    <Slide left delay={1200}>
                        <HoverImage style={{ height: 240, width: 320 }} onClick={() => history.push('/projects')}>
                            <img
                                style={{ objectFit: 'cover', objectPosition: '4px -2px', height: 240, width: 320, cursor: handCursor }}
                                src={MADProject}
                                alt="project"
                            // src="https://s3-alpha-sig.figma.com/img/54d0/0097/71a1648841dd9d623549daeb2da0f2e9?Expires=1620000000&Signature=IZhQi7Z53~SzfnlfpLYZr8WBWaXGYVJsaO6dNvSxnsC3nEPcDoETEkeeNVMjJCDnArxah0Vj4B93sYlbtvWIBPI70rP93sA9XlbygJkxj9KwVs138P~-8065Niu2rPCcU7xbOfyfckSE5fGykMGQuFU2MczVpWL4xZWw2eUAzg0hM0l-HuG7ea~XuM6ANI6b~LcMgBwQgq8b33Ex6W5MevWKU6BJ5cxPP3Kyz8p6HRTzwfoEcc0h5y4dtWW8RLQFABKNb9ASTieKmag7FGx2413sakcOFsNxXnHIlsvuPpc0nlhLOVitu4wWIqZjOk-oa4GbGsqkwQAzC3Sh8tuVHw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
                            />
                        </HoverImage>
                    </Slide>
                    <Slide left delay={600}>
                        <HoverImage translate="translate(160px,40px)" zIndex="2" style={{ height: 240, width: 320 }} onClick={() => history.push('/projects')}>
                            <img
                                style={{ objectFit: 'cover', objectPosition: 'left', height: 240, width: 320, cursor: handCursor }}
                                src={StandWeSpeak}
                                alt="project"
                            // src="https://s3-alpha-sig.figma.com/img/8421/d637/73f27b4116bc8fe4d90a90560ee11a43?Expires=1620000000&Signature=DusxbWS1TdNJprqe0pQFXd9OT8oQLnpE70eBUhxqSLe585~oAsNFBXsNqMwN6tDZVzuBU8a4-n4de~WrJ0WC1EEFF5V~~CAdIceTliVi~zwEjhrnyj~S2QDvu9xO1Sejza~FlAwgTuaI2YbVEDKGXCwWygMKGT3F2gCrHqowFZYhntkOg1T6ah07Fuy1DKfGyBy4JSSyCgPUm4GDNcp56YV1qhH2cfN9bKBa8dYbAip8~tWHBQHNvJvXzHApMg-Q20vItLSUxTbKhPntPnbtfDGhlAJ2eOhMDnUoYDYIdnNS1M6yPgFlR3Zk7dEJS0IgADpawTCTIThEj~ffyr4xRw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
                            />
                        </HoverImage>
                    </Slide>
                    <Slide left>
                        <HoverImage translate="translate(320px,80px)" zIndex="3" style={{ height: 240, width: 320 }} onClick={() => history.push('/projects')}>
                            <Pulse delay={2000} count={4}>
                                <img
                                    style={{ objectFit: 'cover', objectPosition: 'right', height: 240, width: 320, cursor: handCursor }}
                                    src={TwitterRed}
                                    alt="project"
                                // src="https://s3-alpha-sig.figma.com/img/54d0/0097/71a1648841dd9d623549daeb2da0f2e9?Expires=1620000000&Signature=IZhQi7Z53~SzfnlfpLYZr8WBWaXGYVJsaO6dNvSxnsC3nEPcDoETEkeeNVMjJCDnArxah0Vj4B93sYlbtvWIBPI70rP93sA9XlbygJkxj9KwVs138P~-8065Niu2rPCcU7xbOfyfckSE5fGykMGQuFU2MczVpWL4xZWw2eUAzg0hM0l-HuG7ea~XuM6ANI6b~LcMgBwQgq8b33Ex6W5MevWKU6BJ5cxPP3Kyz8p6HRTzwfoEcc0h5y4dtWW8RLQFABKNb9ASTieKmag7FGx2413sakcOFsNxXnHIlsvuPpc0nlhLOVitu4wWIqZjOk-oa4GbGsqkwQAzC3Sh8tuVHw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
                                />
                            </Pulse>
                        </HoverImage>
                    </Slide>
                </FlexCol>
            </FlexRow>
            <FlexRow style={{ marginTop: 64 }}>
                <FloatingTitle style={{ top: '6%' }}>Experience</FloatingTitle>
                <FlexCol basis="90%" style={{ fontSize: font_h4, textAlign: 'center' }}>Where have i worked?</FlexCol>
                <FlexCol basis="90%" style={{ textAlign: 'center', lineHeight: '24px' }}>past companies where i have gained experience from</FlexCol>
                <FlexCol>
                    {screenSize < 800 ?
                        <table className="experience-table">
                            <tr>
                                <th></th>
                                <th>Companies {'&'} Positions</th>
                                <th></th>
                            </tr>
                            <tr><td></td><td>Software engineer at Indian Oil Company Ltd</td></tr>
                            <tr><td></td><td>Freelancer Programmer at The Renal Project</td></tr>
                            <tr><td></td><td>ReactJS Developer at StandWeSpeak</td></tr>
                        </table>
                        :
                        <table className="experience-table">
                            <tr>
                                <th></th>
                                <th>COMPANY NAME</th>
                                <th>POSITION</th>
                                <th>Dated</th>
                            </tr>
                            <Slide up cascade duration={2000}>
                                <tr>
                                    <td style={{ fontWeight: 800, color: 'white' }}>IOCL</td>
                                    <td>Indian Oil Company Ltd.</td>
                                    <td>Software engineer</td>
                                    <td>Jul' 2018 - Jun' 2019</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: 800, color: 'white' }}>TRP</td>
                                    <td>The Renal Project</td>
                                    <td>Freelancer Programmer</td>
                                    <td>Oct' 2019 - Jan' 2020</td>
                                </tr>
                                <tr>
                                    <td style={{ fontWeight: 800, color: 'white' }}>SWS</td>
                                    <td>StandWeSpeak</td>
                                    <td>ReactJS Developer</td>
                                    <td>Nov' 2020 - March' 2020</td>
                                </tr>
                            </Slide>
                        </table>
                    }
                </FlexCol>
            </FlexRow>
            <FlexRow>
                <FloatingTitle>Testimonial</FloatingTitle>
                <FlexCol basis="90%" style={{ fontSize: font_h4, textAlign: 'center' }}>What my superiors/ colleagues/ clients say?</FlexCol>
                <FlexCol basis="90%" style={{ textAlign: 'center', lineHeight: '24px' }}>people with whom i have designed and collaborated with</FlexCol>
                <FlexCol basis="90%" style={{ position: 'relative', height: 500 }}>
                    <div style={{ position: 'absolute', top: 0, bottom: 0, width: '100%', height: '500px', }}>
                        <Slider {...settings}>
                            {
                                testimonials.map((v, i) => {
                                    return (
                                        <div key={i}>
                                            <Zoom opposite>
                                                <TestimonialCard info={v} />
                                            </Zoom>
                                        </div>
                                    )
                                })
                            }
                        </Slider>
                    </div>
                </FlexCol>
            </FlexRow>
            <FlexRow style={{ minHeight: '40vh', marginTop: 64 }}>
                <FlexCol basis="90%" style={{ fontSize: font_h4, textAlign: 'center' }}>Interested in collaborating?</FlexCol>
                <FlexCol basis="90%" style={{ textAlign: 'center', lineHeight: '24px' }}>I’m always open to discuss design work or web hosting opportunities.</FlexCol>
                <FlexCol >
                    <Flash>
                        <HLButton onClick={() => history.push('/contact')}>START A CONVERSATION</HLButton>
                    </Flash>
                </FlexCol>
            </FlexRow>
        </FlexContainer>
    );
}

export default HomePage;